import { render, staticRenderFns } from "./ProgressSimulation.vue?vue&type=template&id=5c84d440&scoped=true"
import script from "./ProgressSimulation.vue?vue&type=script&lang=js"
export * from "./ProgressSimulation.vue?vue&type=script&lang=js"
import style0 from "./ProgressSimulation.vue?vue&type=style&index=0&id=5c84d440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c84d440",
  null
  
)

export default component.exports